import { useMyRegistration, useOwnCorrectionContract } from '@alamo/api';
import { useAuth } from '@alamo/auth';

/** A consulta compartilhada mantém os avisos coerentes com o cadastro, inclusive após uma correção. */
export function useRegistrationAttention() {
  const { isApproved, isLoading, registrationStatus } = useAuth();
  const contract = useOwnCorrectionContract(
    !isLoading && !isApproved && typeof registrationStatus === 'string',
  );
  const { data } = useMyRegistration({
    enabled: !isLoading && !isApproved && typeof registrationStatus === 'string',
    refetchInterval: 30_000,
  });
  const status = isApproved ? registrationStatus : (data?.registrationStatus ?? registrationStatus);
  return {
    needsCorrection: status === 'correction_needed',
    needsSignature: contract.data?.requiresSignature === true,
  };
}
